<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Diagnose" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the Diagnose." }}
      </p>
    </div>
    <div>
      <tabs v-model="activeIndex">
        <!--PING Diagnose-->
        <pane label="PING Diagnose">
          <div class="row">
            <div class="col-lg-12">
              <block-cntr
                :btitle="'PING Diagnose'"
                style="height: 100%"
                :closeButton="false"
              >
                <div class="row">
                  <div style="margin-left: 10px">
                    <form class="form-horizontal" role="form">
                      <div class="form-group">
                        <label class="col-sm-1 control-label" for="ipaddr">{{
                          "IP Address"
                        }}</label>
                        <div
                          class="col-sm-2"
                          :class="{ 'has-error': input_para_check() }"
                        >
                          <input
                            type="text"
                            class="form-control"
                            id="ipaddr"
                            maxlength="15"
                            v-model="diagnoseForm.ipAddr"
                          />
                          <small
                            class="help-block"
                            :style="{
                              display: input_para_check() ? 'block' : 'none',
                            }"
                            >{{ input_para_check() }}
                          </small>
                        </div>

                        <!--操作按钮-->
                        <span>
                          <button
                            type="button"
                            class="btn btn-primary"
                            style="width: 80px; height: 35px"
                            @click="clkPing"
                          >
                            {{ "Ping" }}
                          </button>
                        </span>
                      </div>

                      <div class="col-sm-7">
                        <span style="width: 700px; position: relative">
                          <textarea
                            rows="13"
                            cols="80"
                            class="form-control"
                            readonly="readonly"
                            v-model="pingStr"
                          >
                          </textarea>
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </block-cntr>
            </div>
          </div>
        </pane>
      </tabs>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import ConfirmBox from "@/components/ConfirmBox.vue"
import DialogBox from "@/components/DialogBox"
import tabs from "@/components/Tabs.vue"
import pane from "@/components/Pane.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "diagnose",
  data() {
    return {
      activeIndex: 0,
      pingStr: "",
      diagnoseForm: {
        ipAddr: "",
      },
    }
  },
  components: {
    BlockCntr,
    InfoBox,
    ConfirmBox,
    DialogBox,
    tabs,
    pane,
  },
  created() {},
  methods: {
    clkPing() {
      var tmpPing = {
        ipAddr: this.diagnoseForm.ipAddr,
      }

      var msg = this.input_para_check()
      if (msg != null) {
        this.showAlertBox("warn", "Message", msg)
        return
      }

      //pingStr清零
      this.pingStr = ""

      post("ping_diagnose", tmpPing)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            //this.pingStr = res.data.msg
            //this.showAlertBox("info", "Info", "Config Successful!")
            console.log("******timerGetPingStr")
            this.timerGetPingStr()
          } else {
            this.pingStr = res.data.msg
            //this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          //this.showAlertBox("critical", "error", "Post error!")
        })
    },
    timerGetPingStr() {
      var cnt = 20
      for (let i = cnt; i > 0; i--) {
        setTimeout(() => {
          this.getPingStr()
        }, (cnt - i) * 100)
      }
    },
    getPingStr() {
      console.log("******before getPingStr, pingStr:" + this.pingStr)
      get("ping_diagnose")
        .then((res) => {
          this.pingStr = res.data
          console.log(res.data)
          console.log("******after getPingStr, pingStr:" + this.pingStr)
        })
        .catch((err) => {
          console.log(err)
          this.pingStr = res.data.msg
          console.log("******getPingStr error, pingStr:" + this.pingStr)
        })
    },
    input_para_check() {
      if (this.diagnoseForm.ipAddr != "") {
        if (
          this.diagnoseForm.ipAddr.match(
            /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/
          ) == null
        ) {
          return "ip address must be inputted with A.B.C.D "
        } else {
          var id = this.diagnoseForm.ipAddr.split(".")
          let ip0 = Number(id[0])
          let ip1 = Number(id[1])
          let ip2 = Number(id[2])
          let ip3 = Number(id[3])
          if (
            ip0 < 0 ||
            ip0 > 255 ||
            ip1 < 0 ||
            ip1 > 255 ||
            ip2 < 0 ||
            ip2 > 255 ||
            ip3 < 0 ||
            ip3 > 255
          )
            return "invalid ip address"
        }
      }

      return null
    },
  },
}
</script>
        
